export default "__VITE_ASSET__1QFSy8qu__"